export default "__VITE_ASSET__DqkhEUTc__"